import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

/** `users/{uid}.installOfferDismissed` — owner update, follows the account. */
export async function dismissInstallOffer(uid) {
  if (!uid) return;
  await updateDoc(doc(db, 'users', uid), {
    installOfferDismissed: true,
    updatedAt: serverTimestamp(),
  });
}
